import { ChakraBox, ChakraFlex, Text } from '@equip.health/ui';
import { formatRelativeTime } from '~/lib/util/date.util';
import { useProviderAvatar } from '~/lib/hooks/carePlan/useProviderAvatar';

type Props = {
  noteText: string;
  timestamp: string;
  providerId?: string;
  goalId: string;
};

export const CarePlanGoalCollapsedView = ({
  noteText,
  timestamp,
  providerId,
  goalId,
}: Props) => {
  const { avatarWithTooltip } = useProviderAvatar({
    providerId,
    size: '2xs',
    placement: 'left',
  });

  return (
    <ChakraFlex
      id={`goal-preview-${goalId}`}
      paddingBottom="18px"
      alignItems="center"
      gap="12px"
      width="100%"
    >
      {avatarWithTooltip}
      <ChakraBox gap="12px" flex="1">
        <Text color="neutral.secondary" variant="caption" noOfLines={1}>
          {noteText}
        </Text>
      </ChakraBox>
      <Text color="neutral.secondary" variant="caption" whiteSpace="nowrap">
        {formatRelativeTime(timestamp)}
      </Text>
    </ChakraFlex>
  );
};
